import "slick-carousel/slick/slick.min";



// WEBPACK FOOTER //
// ./scripts/autoload/_slick.js